import { PromoteTabLanguagesDropdown } from './promote-tab-languages-dropdown'
export default PromoteTabLanguagesDropdown
